import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  claimModalHeader: {
    description: 'modal header explaining that this is where a claim for ParcelGuard can be filed',
    defaultMessage: 'File a claim with {insuranceProviderName}',
    id: 'bCcMWZ',
  },
  claimModalBody: {
    description: 'modal body describing the process of what will happen when a claim is filed',
    defaultMessage:
      'To file a claim with {insuranceProviderName} for Shipment {shipmentId}, continue to the claims form. This will open a new window and take you out of ShipStation. Helpful information to have:',
    id: 'vwvYSC',
  },
  claimsModalShipmentDetails: {
    description: 'link that will take the user to shipment details',
    defaultMessage: 'Shipment details for shipment <a>{shipmentId}</a>',
    id: 'yiTSs7',
  },
  claimsModalClaimsInsructions: {
    description: 'link that will take the user to the claims instructions',
    defaultMessage: '<a>{insuranceProviderName} Claims Instructions</a>',
    id: 'emYNxH',
  },
  claimModalFooterButtonCancel: {
    description: 'modal footer button that will close the modal',
    defaultMessage: 'Cancel',
    id: 'kcj6i5',
  },
  claimModalFooterButtonContinue: {
    description: "modal footer button that will take the user to the 'file a claim' portal",
    defaultMessage: 'Continue to {insuranceProviderName}',
    id: '56bT/S',
  },
});
